import { getFetchableStaticUrl, getUrlForStaticApi } from "./urlStaticFiles";

const triggerAnchorDownload = (href, filename, { newTab = false } = {}) => {
  const a = document.createElement("a");
  a.href = href;
  a.download = filename || "file";
  a.rel = "noopener";
  if (newTab) a.target = "_blank";
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

const isStorageErrorPayload = async (response, blob) => {
  const contentType = (response.headers.get("content-type") || "").toLowerCase();
  if (!contentType.includes("xml") && !contentType.includes("text/html") && !contentType.includes("json")) {
    return { isError: false, blob };
  }
  const text = await blob.text();
  if (/AccessDenied|Access Denied|<\s*Error[\s>]/i.test(text)) {
    return { isError: true, blob: null };
  }
  return { isError: false, blob: new Blob([text], { type: contentType || "application/octet-stream" }) };
};

/**
 * Download a file as a blob when possible (no AccessDenied tab).
 * @param {string} url
 * @param {string} [filename]
 * @param {{ allowAnchorFallback?: boolean }} [options]
 * @returns {Promise<boolean>}
 */
const downloadFile = async (url, filename, options = {}) => {
  const { allowAnchorFallback = true } = options;
  if (!url) return false;

  const displayName = (filename || "").split("?")[0] || "file";
  const absolute = getUrlForStaticApi(url);
  const fetchable = getFetchableStaticUrl(url);

  const candidates = [];
  if (fetchable) candidates.push(fetchable);
  if (absolute && absolute !== fetchable) candidates.push(absolute);

  for (const candidate of candidates) {
    try {
      const response = await fetch(candidate, { credentials: "include" });
      if (!response.ok) continue;
      const rawBlob = await response.blob();
      const { isError, blob } = await isStorageErrorPayload(response, rawBlob);
      if (isError || !blob) continue;
      const objectUrl = URL.createObjectURL(blob);
      triggerAnchorDownload(objectUrl, displayName);
      setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
      return true;
    } catch {
      // try next candidate
    }
  }

  if (allowAnchorFallback && absolute) {
    triggerAnchorDownload(absolute, displayName, { newTab: true });
    return true;
  }

  return false;
};

export default downloadFile;
